import { getAllDecisionEngines } from 'lib/api';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import { errorHandler } from 'lib/functions/errors';
import { DecisionEngine as DecisionEngineType } from 'lib/types/models';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DefaultDecisionEngineDialog from './components/DefaultDialog';

export type DecisionEngine = DecisionEngineType & {
  revisionObjective: string;
};

const DecisionEnginesShow = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [decisionEngines, setDecisionEngines] = useState<DecisionEngine[]>([]);
  const [openDefault, setOpenDefault] = useState(false);
  const [selectedEngine, setSelectedEngine] = useState<DecisionEngine | null>(
    null,
  );

  const startButtons: CustomButtonProps[] = [
    {
      action: () => (window.location.href = '/settings/engines/create'),
      name: 'Crear motor',
      color: 'primary',
    },
  ];

  const fetchAllDecisionEngines = async () => {
    try {
      setLoading(true);
      const response = await getAllDecisionEngines(dispatch);
      setDecisionEngines(response);
      setLoading(false);
    } catch (error) {
      errorHandler(dispatch, error, 'Error al obtener los motores de decisión');
    } finally {
      setLoading(false);
    }
  };

  const handleDefault = (id: number) => {
    const engine = decisionEngines.find((engine) => engine.id === id);
    if (!engine) return;
    setSelectedEngine(engine);
    setOpenDefault(true);
  };

  const canDefault = (id: number) => {
    const engine = decisionEngines.find((engine) => engine.id === id);
    if (!engine) return false;
    return !engine.selected;
  };

  const handleEdit = (id: number) => {
    window.location.href = `/settings/engines/edit/${id}`;
  };

  const actions = [
    { action: handleEdit, actionLabel: 'Editar' },
    { action: handleDefault, actionLabel: 'Default', canShow: canDefault },
  ];

  useEffect(() => {
    void fetchAllDecisionEngines();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <>
      <HeaderWithActions
        title="Aquí encontrarás todos los motores de decisión de tu empresa."
        variant="body1"
        buttons={startButtons}
      />
      <EnhancedTable
        dataHeaders={[
          { key: 'name', label: 'Nombre del motor' },
          { key: 'revisionObjective', label: 'Elemento a revisar' },
          { key: 'selected', label: 'Default', type: 'vission' },
          { key: 'engineType', label: 'Tipo de revisión' },
        ]}
        data={decisionEngines}
        actions={actions}
        showActions
        rowsPerPageDefault={10}
      />
      {openDefault && (
        <DefaultDecisionEngineDialog
          selectedEngine={selectedEngine}
          openDefault={openDefault}
          setOpenDefault={setOpenDefault}
          setUp={fetchAllDecisionEngines}
        />
      )}
    </>
  );
};

export default DecisionEnginesShow;
